<template>

  <div class="container">
    <h3 class="main-title">Dirección</h3>
    <form @submit.prevent="submit" novalidate>
      <fieldset>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="street" :class="{'error-text': endpointErrors.street}">Calle:</label>
            <input type="text" name="street" v-model.trim="$v.userInteraction.street.$model" :class="{ 'error-label': $v.userInteraction.street.$error || endpointErrors.street }" placeholder="Calle">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.street.required">La calle es obligatoria</span>
              <span v-if="!$v.userInteraction.street.validateAddress">La calle no puede contener caracteres especiales</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="neighborhood" :class="{'error-text': endpointErrors.neighborhood}">Colonia:</label>
            <input type="text" name="neighborhood" v-model.trim="$v.userInteraction.neighborhood.$model" :class="{ 'error-label': $v.userInteraction.neighborhood.$error || endpointErrors.neighborhood }" placeholder="Colonia">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.neighborhood.required">La colonia es obligatoria</span>
              <span v-if="!$v.userInteraction.neighborhood.validateAddress">La colonia no puede contener caracteres especiales</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="externalNumber">Número externo:</label>
            <input type="text" name="externalNumber" v-model.trim="userInteraction.externalNumber" placeholder="Número externo">
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="internalNumber">Número interno:</label>
            <input type="text" name="internalNumber" v-model="userInteraction.internalNumber" placeholder="Número interno">
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="municipality" :class="{'error-text': endpointErrors.municipality}">Delegación ó municipio:</label>
            <input type="text" name="municipality" v-model.trim="$v.userInteraction.municipality.$model" :class="{ 'error-label': $v.userInteraction.municipality.$error || endpointErrors.municipality }" placeholder="Delegación ó municipio">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.municipality.required">La delegación/municipio es obligatoria</span>
              <span v-if="!$v.userInteraction.municipality.validateAlpha">La delegación/municipio no puede contener números ni caracteres especiales</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="city" :class="{'error-text': endpointErrors.city}">Ciudad:</label>
            <input type="text" name="city" v-model.trim="$v.userInteraction.city.$model" :class="{ 'error-label': $v.userInteraction.city.$error || endpointErrors.city }" placeholder="Ciudad">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.city.required">La ciudad es obligatoria</span>
              <span v-if="!$v.userInteraction.city.validateAlpha">La ciudad no puede contener números ni caracteres especiales</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="state" :class="{'error-text': endpointErrors.state}">Estado:</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.state.$model" :class="{ 'error-label': $v.userInteraction.state.$error || endpointErrors.state }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="state in states" :key="state.pk" :value="state.pk">
                  {{ state.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.state.required">El estado es obligatorio</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="zipCode" :class="{'error-text': endpointErrors.zip_code}">Código postal:</label>
            <input type="text" name="zipCode" v-model.trim="$v.userInteraction.zipCode.$model" :class="{ 'error-label': $v.userInteraction.zipCode.$error || endpointErrors.zip_code }" placeholder="Código postal">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.zipCode.required">El código postal es obligatorio</span>
              <span v-if="!$v.userInteraction.zipCode.numeric">El código postal debe ser numérico</span>
              <span v-if="!$v.userInteraction.zipCode.maxLength">El código postal debe tener 5 dígitos</span>
              <span v-if="!$v.userInteraction.zipCode.minLength">El código postal debe tener 5 dígitos</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="type" :class="{'error-text': endpointErrors.type}">Tipo de vivienda:</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.type.$model" :class="{ 'error-label': $v.userInteraction.type.$error || endpointErrors.type }">
                <option value="" disabled selected>Seleccione:</option>
                <option value="f">Familiar</option>
                <option value="o">Propio</option>
                <option value="r">Rentado</option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.type.required">El tipo de vivienda es obligatorio</span>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <button class="button float-right" @click.prevent="submit()">Siguiente</button>
          </div>
        </div>
        <div class="row">
          <div class="column box-errors">
            <p v-if="errors" class="error">El formulario tiene errores, por favor revísalos antes de seguir.
            </p>
            <p v-else-if="empty" class="error">El formulario está vacío, todos los campos son obligatorios.
            </p>
          </div>
        </div>
      </fieldset>
    </form>
  </div>

</template>

<script>

import { required, minLength, maxLength, numeric }
  from 'vuelidate/lib/validators'

import mixins from '@/mixins/index'
import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

const validateAddress = (field) => /^[a-zA-ZÀ-ÿ0-9\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ0-9\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ0-9\u00f1\u00d1]+$/.test(field)
const validateAlpha = (field) => /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(field)

export default {
  name: 'StepAddress',
  data () {
    return {
      endpointErrors: {
        street: false,
        external_number: false,
        internal_number: false,
        neighborhood: false,
        municipality: false,
        city: false,
        zip_code: false,
        state: false,
        type: false
      },
      errors: false,
      empty: false,
      states: [],
      userInteraction: {
        street: null,
        externalNumber: null,
        internalNumber: null,
        neighborhood: null,
        municipality: null,
        city: null,
        zipCode: null,
        state: '',
        type: ''
      }
    }
  },
  validations: {
    userInteraction: {
      street: { required, validateAddress },
      neighborhood: { required, validateAddress },
      municipality: { required, validateAlpha },
      city: { required, validateAlpha },
      state: { required },
      zipCode: {
        required,
        numeric,
        maxLength: maxLength(5),
        minLength: minLength(5)
      },
      type: { required }
    }
  },
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  methods: {
    sendDataToServer: async function () {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/profile/address/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          street: this.userInteraction.street,
          external_number: this.userInteraction.externalNumber,
          internal_number: this.userInteraction.internalNumber || '',
          neighborhood: this.userInteraction.neighborhood,
          municipality: this.userInteraction.municipality,
          city: this.userInteraction.city,
          zip_code: this.userInteraction.zipCode,
          state: this.userInteraction.state,
          type: this.userInteraction.type
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.nextStep()
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          case 400:
            this.endpointErrors.street = ('street' in response.data)
            this.endpointErrors.external_number = ('external_number' in
              response.data)
            this.endpointErrors.internal_number = ('internal_number' in
              response.data)
            this.endpointErrors.neighborhood = ('neighborhood' in
              response.data)
            this.endpointErrors.municipality = ('municipality' in
              response.data)
            this.endpointErrors.city = ('city' in response.data)
            this.endpointErrors.zip_code = ('zip_code' in
              response.data)
            this.endpointErrors.state = ('state' in response.data)
            this.endpointErrors.type = ('type' in response.data)
            break
          default:
            break
        }
      }
    },
    submit: function () {
      this.empty = !this.$v.userInteraction.$anyDirty
      this.errors = this.$v.userInteraction.$anyError

      if (this.errors === false && this.empty === false) {
        this.sendDataToServer()
      }
    },
    getStates: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/states/',
        params: {
          country: 148
        },
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 200) {
        this.states = response.data
      }
    }
  },
  created: function () {
    this.getStates()
  }
}

</script>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepAddress.vue